export default "__VITE_ASSET__BZUM_SQa__"